import { z } from "zod";
import { ActionCommonParamsSchema } from "../../types";

export const DouyinGetCommentReplyListParamsSchema = ActionCommonParamsSchema.extend({
    commentId: z.string(),
    cursor: z.number().optional(),
    count: z.number().optional(),
});

export type DouyinGetCommentReplyListParams = z.infer<typeof DouyinGetCommentReplyListParamsSchema>;
